import { useState, useEffect } from "react";
import Modal from "../../../components/modal";

const CreditNoteForm = ({ show, onClose, heading, initialData = {}, billsData = {}, onSubmit }) => {
    const [formData, setFormData] = useState({
        billes_id: "",
        amount: "",
        date: "",
        description: "",
    });

    // Autofill form when initialData is provided
    useEffect(() => {
        if (initialData && Object.keys(initialData).length > 0) {
            setFormData({
                billes_id: initialData.billes_id || "",
                amount: initialData.amount || "",
                date: initialData.date ? initialData.date.split("T")[0] : "", // Format date to YYYY-MM-DD
                description: initialData.description || "",
            });
        }
    }, [initialData]);

    // Handle input change
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    // Handle form submission
    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(formData); // Send form data to parent component
        onClose(); // Close modal after submission
    };

    return (
        <Modal
            show={show}
            onClose={onClose}
            heading={heading}
        >
            <form onSubmit={handleSubmit} className="needs-validation" noValidate>
                <div className="row">
                    <div className="mb-3 col-md-12">
                        <label className="form-label">Select Invoice</label>
                        {/* <input
                            type="text"
                            name="bill_id"
                            value={formData.bill_id}
                            onChange={handleChange}
                            className="form-control"
                            required
                        /> */}
                        <select name="billes_id" className="form-control" value={formData.billes_id} onChange={handleChange}>
                            <option value="">Select Option</option>
                            {billsData && billsData.map((e, ind) => (
                                <option key={ind} value={e.id}>{e.Customer?.name} ({e.bill_number})</option>
                            ))}
                        </select>

                    </div>

                    {/* Amount */}
                    <div className="mb-3 col-md-6">
                        <label className="form-label">Amount</label>
                        <input
                            type="number"
                            name="amount"
                            value={formData.amount}
                            onChange={handleChange}
                            className="form-control"
                            required
                        />
                    </div>

                    {/* Date */}
                    <div className="mb-3 col-md-6">
                        <label className="form-label">Date</label>
                        <input
                            type="date"
                            name="date"
                            value={formData.date}
                            onChange={handleChange}
                            className="form-control"
                            required
                        />
                    </div>

                    {/* Description */}
                    <div className="mb-3 col-md-12">
                        <label className="form-label">Description</label>
                        <textarea
                            name="description"
                            value={formData.description}
                            onChange={handleChange}
                            className="form-control"
                            rows="3"
                        ></textarea>
                    </div>
                </div>
                <div className="text-end">
                    <button type="submit" className="btn btn-primary">
                        Save
                    </button>
                </div>
            </form>

        </Modal>
    );
};

export default CreditNoteForm;
